function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { CUSTOM_EXPORT_FORM } from '@engine/actions/action-types';
/**
 * Initial state
 */

var INITIAL_STATE = {
  flashMessage: null,
  hasErrors: false,
  isSubmitting: false,
  isSubmitted: false
};

function formFor(preference) {
  return function customExportFormReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case CUSTOM_EXPORT_FORM(preference).resetForm:
        return _objectSpread({}, INITIAL_STATE);

      case CUSTOM_EXPORT_FORM(preference).responseReceive:
        return _objectSpread(_objectSpread({}, state), {}, {
          flashMessage: action.data.flash_message,
          hasErrors: action.data.errors,
          isSubmitting: false,
          isSubmitted: true
        });

      case CUSTOM_EXPORT_FORM(preference).exportRequest:
        return _objectSpread(_objectSpread({}, state), {}, {
          isSubmitting: true
        });

      case CUSTOM_EXPORT_FORM(preference).requestFail:
        return _objectSpread(_objectSpread({}, state), {}, {
          flashMessage: "".concat(I18n.t('javascript.errors.unable_to_process_request'), " ") + I18n.t('javascript.errors.try_again_later'),
          hasErrors: true,
          isSubmitting: false
        });

      default:
        return state;
    }
  };
}

var customExportFormReducer = function customExportFormReducer(preference) {
  return formFor(preference);
};

export default customExportFormReducer;